import { type FC } from 'react';

const chipIconSvgProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16' as const,
  fill: 'none' as const,
  xmlns: 'http://www.w3.org/2000/svg' as const,
  'aria-hidden': true as const,
};

export const WhySgCoverageMajorCardsIcon: FC = () => (
  <svg {...chipIconSvgProps}>
    <path
      d="M2.66671 3.3335H13.3334C14.0693 3.3335 14.6667 3.93094 14.6667 4.66683V11.3335C14.6667 12.0694 14.0693 12.6668 13.3334 12.6668H2.66671C1.93082 12.6668 1.33337 12.0694 1.33337 11.3335V4.66683C1.33337 3.93094 1.93082 3.3335 2.66671 3.3335V3.3335"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33337 6.6665H14.6667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgCoverageDigitalWalletIcon: FC = () => (
  <svg {...chipIconSvgProps}>
    <path
      d="M12.6667 4.66667V2.66667C12.6667 2.29872 12.3679 2 12 2H3.33333C2.59745 2 2 2.59745 2 3.33333C2 4.06922 2.59745 4.66667 3.33333 4.66667H13.3333C13.7013 4.66667 14 4.96539 14 5.33333V8H12C11.2641 8 10.6667 8.59745 10.6667 9.33333C10.6667 10.0692 11.2641 10.6667 12 10.6667H14C14.3679 10.6667 14.6667 10.3679 14.6667 10V8.66667C14.6667 8.29872 14.3679 8 14 8"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3.3335V12.6668C2 13.4027 2.59745 14.0002 3.33333 14.0002H13.3333C13.7013 14.0002 14 13.7014 14 13.3335V10.6668"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgCoverageBankTransferIcon: FC = () => (
  <svg {...chipIconSvgProps}>
    <path
      d="M6.66663 12.0002V7.3335"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.41328 1.46555C7.78399 1.28548 8.21714 1.28695 8.58661 1.46955L13.8306 4.03422C14.1479 4.18955 14.0373 4.66689 13.6839 4.66689H2.31595C1.96261 4.66689 1.85261 4.18955 2.16928 4.03422L7.41328 1.46555"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33337 12.0002V7.3335"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12.0002V7.3335"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 14.6665H14" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4 12.0002V7.3335"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgCoverageLocalMethodsIcon: FC = () => (
  <svg {...chipIconSvgProps}>
    <path
      d="M13.3333 6.66683C13.3333 9.9955 9.64063 13.4622 8.40063 14.5328C8.16332 14.7113 7.8366 14.7113 7.59929 14.5328C6.35929 13.4622 2.66663 9.9955 2.66663 6.66683C2.66663 3.72328 5.05641 1.3335 7.99996 1.3335C10.9435 1.3335 13.3333 3.72328 13.3333 6.66683"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6.6665C6 7.77033 6.89617 8.6665 8 8.6665C9.10383 8.6665 10 7.77033 10 6.6665C10 5.56267 9.10383 4.6665 8 4.6665C6.89617 4.6665 6 5.56267 6 6.6665V6.6665"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
